import axiosInstance from "../../../helpers/api";

export const getPracticeUsers = (formData) => {
  const page = formData?.payload || 1;
  const name = formData?.name || "";
  return axiosInstance.get(
    `/asquera_practice/users?page=${page}&name=${name}`
  );
};

export const getPracticeSubjects = () => {
  return axiosInstance.get("/asquera_practice/subjects");
};

export const getActiveSubscriptions = (subjectId) => {
  const params = {};
  if (subjectId) {
    params.subject_id = subjectId;
  }
  return axiosInstance.get("/asquera_practice/subscriptions/list_active", {
    params,
  });
};

export const createPracticeSubscription = (payload) => {
  return axiosInstance.post("/asquera_practice/subscriptions", payload);
};
